<template>
  <section id="contact" class="contact fade-in section">
    <h2><i class="fas fa-map-marker-alt"></i> {{ $t('contact.branches') }}</h2>
    <div class="contact-container">
      <div class="contact-info">
        <div class="branches">
          <div class="branch">{{ $t('contact.khamis_mushait') }}<br><a href="tel:+9660552767493">0552767493</a></div>
          <div class="branch">{{ $t('contact.khamis_mushait') }}<br><a href="tel:+9660552126620">0552126620</a></div>
          <div class="branch">{{ $t("contact.jeddah") }}<br><a href="tel:+9660534042517">0534042517</a></div>
          <div class="branch">{{ $t("contact.abha") }}<br><a href="tel:+9660501385560">0501385560</a></div>
          <div class="branch">{{ $t("contact.besha") }}<br><a href="tel:+9660532269814">0532269814</a></div>
          <div class="branch">{{ $t("contact.madinah_al_hizam") }}<br><a href="tel:+9660537487883">0537487883</a></div>
          <div class="branch">{{ $t("contact.madinah_al_salam") }}<br><a href="tel:+9660148154032">0148154032</a></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactSection',
  data() {
    return {
      formFields: [
        { label: 'contact.form.name', type: 'text' },
        { label: 'contact.form.email', type: 'email' },
        { label: 'contact.form.phone', type: 'tel' },
        { label: 'contact.form.message', type: 'textarea' }
      ]
    };
  },
  methods: {
    handleSubmit() {
      alert(this.$t('contact.sent'));
    }
  }
};
</script>

<style scoped>
.section { padding: 80px 10%; text-align: center; background: #f8f9fa; }
.contact-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.contact-info, .contact-form {
  flex: 1;
  min-width: 300px;
  padding: 1rem;
}
.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}
input, textarea {
  padding: 0.7rem;
  border: 1px solid #ccc;
  border-radius: 8px;
}
.submit-btn {
  background: #00c4fc;
  color: white;
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
.submit-btn:hover {
  background: #00a7da;
}
</style>
